import styled from 'styled-components';
import { Checkbox } from '@mui/material';
import { theme } from '../../styles/theme';
export const Wrapper = styled(Checkbox) `
  && {
    &.MuiCheckbox-colorPrimary {
      color: ${theme.colors.buttonBackgroundHover};

      &:checked {
        color: ${theme.colors.buttonBackgroundHover};
      }
    }

    &.MuiCheckbox-colorSecondary {
      color: ${theme.colors.buttonSecondaryBackgroundActive};

      &:checked {
        color: ${theme.colors.buttonSecondaryBackgroundActive};
      }
    }
  }
`;
